import { works } from "@/mocks/works";
import SectionHeading from "@/components/feature/SectionHeading";

export default function LatestUpdates() {
  const updates = works.slice(0, 5);
  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
      <div className="grid lg:grid-cols-5 gap-6 lg:gap-10 items-start">
        <div className="lg:col-span-3">
          <SectionHeading
            eyebrow="LIVE UPDATE"
            title="今日更新 · 实时追更"
            desc="热门韩漫保持日更同步，新作上线第一时间收录，不错过任何一话。"
          />
          <div className="space-y-3">
            {updates.map((w, i) => (
              <div
                key={w.id}
                className="flex items-center gap-4 rounded-lg bg-background-100 border border-background-200/70 p-3 hover:border-primary-400/60 transition-colors"
              >
                <div className="w-14 h-18 shrink-0 rounded-md overflow-hidden">
                  <img src={w.image} alt={w.title} className="w-14 h-[68px] object-cover object-top" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <h3 className="font-heading text-sm text-foreground-950 truncate">{w.title}</h3>
                    <span className="text-[11px] px-2 py-0.5 rounded-full bg-accent-500/15 text-accent-500 font-bold">
                      {w.update}
                    </span>
                  </div>
                  <p className="mt-1 text-xs text-foreground-600">{w.genre} · {w.chapters}</p>
                </div>
                <span className="hidden sm:block text-lg text-foreground-600/40 font-heading">{i + 1}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-2 rounded-xl bg-background-100 border border-background-200/70 p-5 md:p-6">
          <span className="text-xs text-primary-500 font-bold uppercase tracking-widest">QUICK TIPS</span>
          <h3 className="mt-2 font-heading text-lg text-foreground-950">追更小贴士</h3>
          <ul className="mt-4 space-y-3 text-sm text-foreground-700 leading-relaxed">
            <li className="flex gap-2.5">
              <span className="w-5 h-5 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-[10px] shrink-0 mt-0.5">1</span>
              认准标注"日更"的资源站，每天都有新内容可看。
            </li>
            <li className="flex gap-2.5">
              <span className="w-5 h-5 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-[10px] shrink-0 mt-0.5">2</span>
              多站点备选，遇到线路波动可随时切换续看。
            </li>
            <li className="flex gap-2.5">
              <span className="w-5 h-5 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-[10px] shrink-0 mt-0.5">3</span>
              手机端优先使用APP，缓存离线也能顺畅追更。
            </li>
            <li className="flex gap-2.5">
              <span className="w-5 h-5 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-[10px] shrink-0 mt-0.5">4</span>
              完结作品"全集在线"，一口气看完不等待。
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}